import * as React from "react";

import { Roles } from "../config/security";

import BaseMiddleware                  from "../Middleware/Base/BaseMiddleware";
import HomeViewModel                   from "../ViewModel/HomeViewModel";
import LoginViewModel                  from "../ViewModel/Login/LoginViewModel";
import { Container }                   from "typedi";
import { MiddlewareHandlerService }    from "../Service/MiddlewareHandlerService";
import GalleryViewModel                from "../ViewModel/Gallery/View/GalleryViewModel";
import NewEditGalleryViewModel         from "../ViewModel/Gallery/CreateOrEdit/NewEditGalleryViewModel";
import PromotionViewModel              from "../ViewModel/Promotion/View/PromotionViewModel";
import CreateOrEditPromotionViewModel  from "../ViewModel/Promotion/CreateOrEdit/CreateOrEditPromotionViewModel";
import TutorialViewModel               from "../ViewModel/Tutorials/View/TutorialViewModel";
import CreateOrEditTutorialViewModel   from "../ViewModel/Tutorials/CreateOrEdit/CreateOrEditTutorialViewModel";
import ContactUsViewModel              from "../ViewModel/ContactUs/View/ContactUsViewModel";
import AboutUsViewModel                from "../ViewModel/AboutUs/View/AboutUsViewModel";
import CreateOrEditAboutUsViewModel    from "../ViewModel/AboutUs/CreateOrEdit/CreateOrEditAboutUsViewModel";
import UserViewModel                   from "../ViewModel/Users/View/UserViewModel";
import CreateOrEditUserViewModel       from "../ViewModel/Users/CreateOrEdit/CreateOrEditUserViewModel";
import CreateOrEditPagesViewModel      from "../ViewModel/PageSeo/CreateOrEdit/CreateOrEditPagesViewModel";
import PageViewModel                   from "../ViewModel/PageSeo/View/PageViewModel";
import OccupationViewModel             from "../ViewModel/Occupation/View/OccupationViewModel";
import CreateOrEditOccupationViewModel from "../ViewModel/Occupation/CreateOrEdit/CreateOrEditOccupationViewModel";
import RecommendationPersonViewModel   from "../ViewModel/RecomendationPerson/View/RecommendationPersonViewModel";
import CreateOrEditRecommendationPersonViewModel
                                     from "../ViewModel/RecomendationPerson/CreateOrEdit/CreateOrEditRecommendationPersonViewModel";
import { RoleMiddleware }            from "../Middleware/RoleMiddleware";
import ProductViewModel                  from "../ViewModel/Product/View/ProductViewModel";
import CreateOrEditProductViewModel      from "../ViewModel/Product/CreateOrEdit/CreateOrEditProductViewModel";
import CategoryViewModel                 from "../ViewModel/Category/View/CategoryViewModel";
import CreateOrEditCategoryViewModel     from "../ViewModel/Category/CreateOrEdit/CreateOrEditCategoryViewModel";
import MethodTransportViewModel          from "../ViewModel/MethodTransport/View/MethodTransportViewModel";
import CreateOrEditMethodTransportViewModel
                                         from "../ViewModel/MethodTransport/CreateOrEdit/CreateOrEditMethodTransportViewModel";
import OrderViewModel                    from "../ViewModel/Order/View/OrderViewModel";
import OrderDetailViewModel              from "../ViewModel/Order/View/OrderDetailViewModel";
import ActionViewModel                   from "../ViewModel/Action/View/ActionViewModel";
import ColorPaletteViewModel             from "../ViewModel/ColorPalette/View/ColorPaletteViewModel";
import CreateOrEditColorPaletteViewModel
                                         from "../ViewModel/ColorPalette/CreateOrEdit/CreateOrEditColorPaletteViewModel";

interface Route {
    auth?: boolean;
    component: React.ComponentType;
    exact?: boolean;
    middleware?: BaseMiddleware[];
    options?: any;
    name: string;
    path: string;
}

const replacer = (tpl: string, data: any) => {
    return tpl.replace(/\w*(:\w+\??)/g, ($1, $2) => data[$2.replace(":", "")]);
};

export const renderRoute = (routeName: PageNames, params?: any): string => {
    const route = routesList.find(item => item.name === routeName);

    if (!route) return "/";

    return replacer(route.path, params || {});
};

const middlewareHandler = Container.get(MiddlewareHandlerService);

export enum PageNames {
    aboutUsAddPage               = "about-us-add-page",
    aboutUsEditPage              = "about-us-edit-page",
    aboutUsPage                  = "about-us-page-view",

    categoryAddPage              = "category-add-page",
    categoryEditPage             = "category-edit-page",
    categoryPage                 = "category-page-view",

    contactUsPage                = "contact-us-page",
    contactUsPageView            = "contact-us-page-view",

    galleryAddPage               = "gallery-add-page",
    galleryEditPage              = "gallery-edit-page",
    galleryPage                  = "gallery-page",

    homePage                     = "home-page",
    loginPage                    = "login-page",

    occupationAddPage            = "occupation-add-page",
    occupationEditPage           = "occupation-edit-page",
    occupationPage               = "occupation-page-view",

    pageAddPage                  = "page-add-page",
    pageEditPage                 = "page-edit-page",
    pagePage                     = "page-page-view",

    promotionAddPage             = "promotion-add-page",
    promotionEditPage            = "promotion-edit-page",
    promotionPage                = "promotion-page",

    tutorialAddPage              = "tutorial-add-page",
    tutorialEditPage             = "tutorial-edit-page",
    tutorialPage                 = "tutorial-page",

    userAddPage                  = "user-add-page",
    userEditPage                 = "user-edit-page",
    userPage                     = "user-page-view",

    productAddPage               = "product-add-page",
    productEditPage              = "product-edit-page",
    productPage                  = "product-page-view",

    recommendationPersonAddPage  = "recommendation-person-add-page",
    recommendationPersonEditPage = "recommendation-person-edit-page",
    recommendationPersonPage     = "recommendation-person-page-view",

    methodTransportAddPage       = "method-transport-add-page",
    methodTransportEditPage      = "method-transport-edit-page",
    methodTransportPage          = "method-transport-page-view",

    colorPaletteAddPage       = "color-palette-add-page",
    colorPaletteEditPage      = "color-palette-edit-page",
    colorPalettePage          = "color-palette-page-view",

    orderPage                    = "order-page-view",
    orderDetailPage              = "order-detail-page-view",

    actionPage                    = "action-page-view",
}

export const routesList: Route[] = [
    {
        auth     : false,
        component: LoginViewModel,
        exact    : true,
        name     : PageNames.loginPage,
        options  : {
            needPaper: false
        },
        path     : "/login"
    },
    {
        auth     : true,
        component: HomeViewModel,
        exact    : true,
        name     : PageNames.homePage,
        path     : "/",
    },
    {
        auth      : true,
        component : GalleryViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.galleryPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.GALLERY,
            ]
        },
        path      : "/galleries",
    },
    {
        auth      : true,
        component : NewEditGalleryViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.galleryAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.GALLERY,
            ]
        },
        path      : "/gallery/add",
    },
    {
        auth      : true,
        component : NewEditGalleryViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.galleryEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.GALLERY,
            ]
        },
        path      : "/gallery/:id",
    },
    {
        auth      : true,
        component : PromotionViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.promotionPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PROMOTION,
            ]
        },
        path      : "/promotions",
    },
    {
        auth      : true,
        component : CreateOrEditPromotionViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.promotionAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PROMOTION,
            ]
        },
        path      : "/promotion/add",
    },
    {
        auth      : true,
        component : CreateOrEditPromotionViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.promotionEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PROMOTION,
            ]
        },
        path      : "/promotion/:id",
    },
    {
        auth      : true,
        component : TutorialViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.tutorialPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.TUTORIAL,
            ]
        },
        path      : "/tutorials",
    },
    {
        auth      : true,
        component : CreateOrEditTutorialViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.tutorialAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.TUTORIAL,
            ]
        },
        path      : "/tutorial/add",
    },
    {
        auth      : true,
        component : CreateOrEditTutorialViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.tutorialEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.TUTORIAL,
            ]
        },
        path      : "/tutorial/:id",
    },
    {
        auth      : true,
        component : ContactUsViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.contactUsPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.CONTACT_US,
            ]
        },
        path      : "/contact-us",
    },
    {
        auth      : true,
        component : AboutUsViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.aboutUsPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.ABOUT_US,
            ]
        },
        path      : "/about-us",
    },
    {
        auth      : true,
        component : CreateOrEditAboutUsViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.aboutUsAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.ABOUT_US,
            ]
        },
        path      : "/about-us/add",
    },
    {
        auth      : true,
        component : CreateOrEditAboutUsViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.aboutUsEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.ABOUT_US,
            ]
        },
        path      : "/about-us/:id",
    },
    {
        auth      : true,
        component : UserViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.userPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.USER,
            ]
        },
        path      : "/user"
    },
    {
        auth     : true,
        component: CreateOrEditUserViewModel,
        exact    : true,
        name     : PageNames.userAddPage,
        options  : {
            needPaper: true,
            roles    : [
                Roles.USER,
            ]
        },
        path     : "/user/add",
    },
    {
        auth      : true,
        component : CreateOrEditUserViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.userEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.USER,
            ]
        },
        path      : "/user/:id",
    },
    {
        auth      : true,
        component : PageViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.pagePage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PAGE,
            ]
        },
        path      : "/page",
    },
    {
        auth      : true,
        component : CreateOrEditPagesViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.pageAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PAGE,
            ]
        },
        path      : "/page/add",
    },
    {
        auth      : true,
        component : CreateOrEditPagesViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.pageEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PAGE,
            ]
        },
        path      : "/page/:id",
    },
    {
        auth      : true,
        component : OccupationViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.occupationPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.OCCUPATION,
            ]
        },
        path      : "/occupation",
    },
    {
        auth      : true,
        component : CreateOrEditOccupationViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.occupationAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.OCCUPATION,
            ]
        },
        path      : "/occupation/add",
    },
    {
        auth      : true,
        component : CreateOrEditOccupationViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.occupationEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.OCCUPATION,
            ]
        },
        path      : "/occupation/:id",
    },
    {
        auth      : true,
        component : RecommendationPersonViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.recommendationPersonPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.RECOMMENDATION_PERSON,
            ]
        },
        path      : "/recommendation-person",
    },
    {
        auth      : true,
        component : CreateOrEditRecommendationPersonViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.recommendationPersonAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.RECOMMENDATION_PERSON,
            ]
        },
        path      : "/recommendation-person/add",
    },
    {
        auth      : true,
        component : CreateOrEditRecommendationPersonViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.recommendationPersonEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.RECOMMENDATION_PERSON,
            ]
        },
        path      : "/recommendation-person/:id",
    },

    {
        auth      : true,
        component : ProductViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.productPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PRODUCT,
            ]
        },
        path      : "/product",
    },
    {
        auth      : true,
        component : CreateOrEditProductViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.productAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PRODUCT,
            ]
        },
        path      : "/product/add",
    },
    {
        auth      : true,
        component : CreateOrEditProductViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.productEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.PRODUCT,
            ]
        },
        path      : "/product/:id",
    },

    {
        auth      : true,
        component : CategoryViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.categoryPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.CATEGORY_PRODUCT,
            ]
        },
        path      : "/category",
    },
    {
        auth      : true,
        component : CreateOrEditCategoryViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.categoryAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.CATEGORY_PRODUCT,
            ]
        },
        path      : "/category/add",
    },
    {
        auth      : true,
        component : CreateOrEditCategoryViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.categoryEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.CATEGORY_PRODUCT,
            ]
        },
        path      : "/category/:id",
    },
    {
        auth      : true,
        component : MethodTransportViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.methodTransportPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.METHOD_TRANSPORT,
            ]
        },
        path      : "/method-transport",
    },
    {
        auth      : true,
        component : CreateOrEditMethodTransportViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.methodTransportAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.METHOD_TRANSPORT,
            ]
        },
        path      : "/method-transport/add",
    },
    {
        auth      : true,
        component : CreateOrEditMethodTransportViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.methodTransportEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.METHOD_TRANSPORT,
            ]
        },
        path      : "/method-transport/:id",
    },
    {
        auth      : true,
        component : ColorPaletteViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.colorPalettePage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.METHOD_TRANSPORT,
            ]
        },
        path      : "/color-palette",
    },
    {
        auth      : true,
        component : CreateOrEditColorPaletteViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.colorPaletteAddPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.METHOD_TRANSPORT,
            ]
        },
        path      : "/color-palette/add",
    },
    {
        auth      : true,
        component : CreateOrEditColorPaletteViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.colorPaletteEditPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.METHOD_TRANSPORT,
            ]
        },
        path      : "/color-palette/:id",
    },
    {
        auth      : true,
        component : OrderViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.orderPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.ORDER,
            ]
        },
        path      : "/order",
    },
    {
        auth      : true,
        component : OrderDetailViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.orderDetailPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.ORDER,
            ]
        },
        path      : "/order/:id",
    },
    {
        auth      : true,
        component : ActionViewModel,
        exact     : true,
        middleware: [
            middlewareHandler.getMiddleware(RoleMiddleware.getAlias())
        ],
        name      : PageNames.actionPage,
        options   : {
            needPaper: true,
            roles    : [
                Roles.ADMIN,
            ]
        },
        path      : "/action",
    },
];
